import React, { Component } from "react";
import { Form, Field } from "redux-form";

class UpdateFolderForm extends Component {
  render() {
    const disabled =
      this.props.invalid || this.props.submitting || this.props.pristine;

    return (
      <Form
        className="pa2 ph9 pv1"
        autoComplete="off"
        onSubmit={this.props.handleSubmit}
      >
        {this.props.error && (
          <div className="form__error">{this.props.error}</div>
        )}
        <Field
          className="form__field"
          name="title"
          component="input"
          type="text"
        />

        <Field
          className="form__field"
          name="id"
          component="input"
          type="hidden"
        />

        <div className="mt2 tc">
          {/* cancel */}
          <button
            type="button"
            className="button mr3"
            onClick={this.props.handleCancel}
          >
            {this.props.t("common:cancelButton")}
          </button>

          {/* submit */}
          <button className="button" disabled={disabled} type="submit">
          {this.props.t("common:saveButton")}&nbsp;<i className="i-arrow-right f7" />
          </button>
        </div>
      </Form>
    );
  }
}

export default UpdateFolderForm;



// WEBPACK FOOTER //
// ./src/components/forms/UpdateFolderForm.js